/// <reference path="../HTML/Container/Container.ts" />
namespace HA.Core.Entity {
    import NavigationContainer = HA.Core.HTML.Container;

    export class NavigationAppManager extends Entity {
        /**
         *
         * @param app
         */
        public update(app: HANavigationApp) {
            if (! app) {
                return;
            }
            this.setApp(app);
            this.getAppContainer().replaceByTag(app.getTag());
        }

        /**
         * @param data
         */
        public updateInfo(data: Map<string, any>) {
            const app = this.getApp();
            if (app) {
               // ptime(app);
                app.updateInfo(data);
            }
        }

        public hide() {
            this.getAppContainer().hide();
        }

        public show() {
            this.getAppContainer().show();
        }

        protected getApp(): HANavigationApp {
            return this.get("app");
        }

        protected setApp(app: App) {
            this.addToData("app", app);
        }

        /**
         *
         * @returns {NavigationContainer}
         */
        protected getAppContainer(): NavigationContainer {
            return this.get("navigationContainer");
        }

        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            const data2 = toMap(data);
            data2.delete("navigationContainer");
            const nav = new NavigationContainer(data2)
            this.addToData("navigationContainer", nav);
        }
    }
}
